import { Badge, Button, ButtonGroup, Link, Text } from '@shopify/polaris';
import { ExternalIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { IntegrationConfig, IntegrationStatus } from '../../types';
import { StyledIntegrationCard } from './styled';

interface IntegrationCardProps {
  config: IntegrationConfig;
  status?: IntegrationStatus;
  isFetching?: boolean;
  onOpenPanel?: () => void;
}

const IntegrationCard = ({ config, status, isFetching, onOpenPanel }: IntegrationCardProps) => {
  const showStatusChip = config.connectable && !!status && status !== 'disconnected';
  const connectActionLabel = status === 'active' ? 'Manage' : 'Connect';

  return (
    <StyledIntegrationCard>
      <div className="integration-avatar">
        <img src={config.avatar} alt={config.avatarAlt || 'Logo'} />
      </div>
      <div className="integration-content">
        <div className="integration-heading">
          <Text variant="headingSm" as="h6">
            {config.title}
          </Text>
          {showStatusChip && (
            <Badge tone={status === 'active' ? 'success' : undefined}>
              {status === 'active' ? 'Connected' : 'Needs reconnect'}
            </Badge>
          )}
        </div>
        <p className="integration-description">
          {`${config.description} `}
          {config.platformLink && <Link url={config.platformLink}>Help doc</Link>}
        </p>
      </div>
      <div className="integration-actions">
        <ButtonGroup>
          {config.connectable && (
            <Button variant="primary" onClick={onOpenPanel} disabled={isFetching}>
              {connectActionLabel}
            </Button>
          )}
          <Link url={config.getAppLink} external>
            <Button icon={ExternalIcon}>Get App</Button>
          </Link>
        </ButtonGroup>
      </div>
    </StyledIntegrationCard>
  );
};

export default memo(IntegrationCard);